__turbopack_context__.v({
  "feeSectionProgramTemplete": "FeeSectionProgramTempleteLp-module-scss-module__amPGfa__feeSectionProgramTemplete",
  "imageLabel": "FeeSectionProgramTempleteLp-module-scss-module__amPGfa__imageLabel",
  "sublabel": "FeeSectionProgramTempleteLp-module-scss-module__amPGfa__sublabel",
  "tile": "FeeSectionProgramTempleteLp-module-scss-module__amPGfa__tile",
});
